import { render, staticRenderFns } from "./Targets.vue?vue&type=template&id=b2854d98&lang=pug&"
import script from "./Targets.vue?vue&type=script&lang=ts&"
export * from "./Targets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports